import "./RiskDashboardActionsComponent.scss";
import {RiskSummary} from "../../models/risk-model/RiskSummary";
import {RiskDashboardViewStore} from "../../store/RiskDashboardViewStore";
import {IOnDestroy, IOnInit, IScope} from "angular";
import {ReplaySubject} from "rxjs";
import {CurrentUserService} from "../../../../services/user/CurrentUserService";

export const RiskDashboardActions = "riskDashboardActions";

export function riskDashboardActions() {
    return {
        templateUrl: "app/risk/dashboard/components/actions/RiskDashboardActionsComponent.html",
        bindings: {
            viewStore: "<"
        },
        controllerAs: "ctrl",
        controller: RiskDashboardActionsComponentController
    };
}

export class RiskDashboardActionsComponentController implements IOnInit, IOnDestroy {

    public readonly viewStore: RiskDashboardViewStore;

    public model: RiskSummary;
    public totalStel: number;
    public stelCash: number;

    public isRiskManager = false;
    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(private $scope: IScope,
                       private currentUserService: CurrentUserService) {
        this.isRiskManager = currentUserService.isRiskManager();
    }

    public $onInit(): void {
        this.viewStore
            .model
            .takeUntil(this.destroyed$)
            .map((viewModel) => viewModel.riskSummary)
            .do((model) => this.model = model)
            .do(() => this.$scope.$applyAsync())
            .subscribe();
        this.viewStore
            .totalStel
            .takeUntil(this.destroyed$)
            .do((stel) => this.totalStel = stel)
            .do(() => this.$scope.$applyAsync())
            .subscribe();
        this.viewStore
            .stelCash
            .takeUntil(this.destroyed$)
            .do((cash) => this.stelCash = cash)
            .do(() => this.$scope.$applyAsync())
            .subscribe();
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
